import React, {useEffect, useState} from 'react';
import {TodoWCddOptions, InviteSendJobTodoWRecOptions, InviteSendJobTodoWRec} from "@pages/dvtjcuv/common/Constant";
import Select from "react-select";
import {stringToOption} from "@app/utils/CommonUtils";
import {EmailInviteMode} from "@pages/candidate/list/DVTJCUVEmailInviteModal";


const DVTJCUVNextFollowUpPlan = (props) => {
    const [nextFUPlan, setNextFUPlan] = useState({
        current_fu_campaign: "",
        next_fu_campaign: "",
        current_fu_strategy_date_time: "",
        next_fu_strategy_date_time: "",
        todo_w_cdd_dvtjcuv: "To ME follow up",
        invite_send_job_todo_w_rec: InviteSendJobTodoWRec.TO_ME_FOLLOW_UP,
        // Dùng chung với current_fu_campaign và current_fu_strategy_date_time nên xóa đi
        // rec_current_fu_strategy_date_time: "",
        // rec_current_fu_campaign: "",
    });

    const {mode, nextFollowUpPlan, onChange} = props

    useEffect(() => {
        if (nextFollowUpPlan) {
            setNextFUPlan({...nextFollowUpPlan})
        }
    },[nextFollowUpPlan])

    const onChangeNextFollowUpPlan = (event, field) => {
        console.log("onChangeNextFollowUpPlan")
        if (field === "todo_w_cdd_dvtjcuv" || field === "invite_send_job_todo_w_rec") {
            nextFUPlan[field] = event
        } else {
            nextFUPlan[event.target.name] = event.target.value
        }
        setNextFUPlan({...nextFUPlan})
        if (onChange) {
            onChange(nextFUPlan)
        }
    }

    return (
        <>
            {mode === EmailInviteMode.INVITE_EMAIL_FU &&
                <div className={'card card-default'}>
                    <div className='card-header'>
                        <h3 className='card-title text-bold'>Follow up This time</h3>
                    </div>
                    <div className='card-body row'>
                        <>
                            <div className='form-group col-sm-6'>
                                <label>FU Strategy (This time)</label>
                                <input type='text' className='form-control' placeholder='FU Strategy (This time)'
                                       value={nextFUPlan.current_fu_strategy_date_time}
                                       name={'current_fu_strategy_date_time'}
                                       onChange={event => onChangeNextFollowUpPlan(event)}/>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <label>FU Compaign (This time)</label>
                                <input type='text' className='form-control' placeholder='FU Compaign (This time)'
                                       value={nextFUPlan.current_fu_campaign}
                                       name={'current_fu_campaign'}
                                       onChange={event => onChangeNextFollowUpPlan(event)}/>
                            </div>
                        </>
                    </div>
                </div>
            }
            {mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU &&
                <div className={'card card-default'}>
                    <div className='card-header'>
                        <h3 className='card-title text-bold'>Follow up This time</h3>
                    </div>
                    <div className='card-body row'>
                        <>
                            <div className='form-group col-sm-6'>
                                <label>(REC) FU Strategy (Next time)</label>
                                <input type='text' className='form-control' placeholder='(REC) FU Strategy (This time)'
                                    value={nextFUPlan.current_fu_strategy_date_time}
                                    name={'current_fu_strategy_date_time'} onChange={event => onChangeNextFollowUpPlan(event)}/>
                            </div>
                            <div className='col-sm-6 form-group'>
                                <label>(REC) FU Compaign (Next time)</label>
                                <input type='text' className='form-control' placeholder='(REC) FU Compaign (Next time)'
                                    value={nextFUPlan.current_fu_campaign}
                                    name={'current_fu_campaign'} onChange={event => onChangeNextFollowUpPlan(event)}/>
                            </div>
                        </>
                    </div>
                </div>
            }
            <div className={'card card-default'}>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Plan for next Follow up</h3>
                </div>
                <div className='card-body row'>
                    <>
                        <div className='form-group col-sm-6'>
                            <label>FU Strategy (Next time)</label>
                            <input type='text' className='form-control' placeholder='FU Strategy (Next time)'
                                value={nextFUPlan.next_fu_strategy_date_time}
                                name={'next_fu_strategy_date_time'} onChange={event => onChangeNextFollowUpPlan(event)}/>
                        </div>
                        <div className='col-sm-6 form-group'>
                            <label>FU Compaign (Next time)</label>
                            <input type='text' className='form-control' placeholder='FU Compaign (Next time)'
                                value={nextFUPlan.next_fu_campaign}
                                name={'next_fu_campaign'} onChange={event => onChangeNextFollowUpPlan(event)}/>
                        </div>
                    </>
                    
                    {mode !== EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB
                         && mode !== EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU &&
                    <div className='col-sm-6 form-group'>
                        <label>To do w Cdd (DVTJCUV)</label>
                        {/*<input type='text' className='form-control' placeholder='To do w Cdd (DVTJCUV)'*/}
                        {/*       value={nextFUPlan.todo_w_cdd_dvtjcuv}*/}
                        {/*       name={'todo_w_cdd_dvtjcuv'} onChange={event => onChangeNextFollowUpPlan(event)}/>*/}
                        <Select options={TodoWCddOptions}
                                value={stringToOption(nextFUPlan.todo_w_cdd_dvtjcuv)}
                                isMulti
                                name={'todo_w_cdd_dvtjcuv'}
                                onChange={value => {
                                    onChangeNextFollowUpPlan(value, 'todo_w_cdd_dvtjcuv');
                                }}
                        />
                    </div>
                    }
                    {(mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB || mode === EmailInviteMode.INVITE_EMAIL_INVITE_SEND_JOB_FU) &&
                    <div className='col-sm-6 form-group'>
                        <label>To do with Rec (mời gửi job)</label>
                        <Select options={InviteSendJobTodoWRecOptions}
                                value={stringToOption(nextFUPlan.invite_send_job_todo_w_rec, false)}
                                name={'invite_send_job_todo_w_rec'}
                                onChange={value => {
                                    onChangeNextFollowUpPlan(value, 'invite_send_job_todo_w_rec');
                                }}
                        />
                    </div>
                    }
                </div>
            </div>
        </>
    )
}

export default DVTJCUVNextFollowUpPlan;
